import React from 'react';
import FundingProsAndCons from './FundingProsAndCons';
import ComparisonGraph from './ComparisonGraph';
import CalculatePayments from "./calculation/Calculation.js";
import UpdateParentWindow from "./update-parent-window/Updater.js";

class FundingModel extends React.Component {
  constructor(props) {
    super(props);
    this.animToggleTimer = [];
    this.toggleAnimDuration = 250;
    this.state = {
      curCard: null,
      curTab: null,
      toggling: false,
      selectedFundings: this.props.state.selectedFundings
    };
  };

  maxSelections(selectionsAmount) {
    return selectionsAmount === 3;
  }

  selectFundingModel(fm) {
    let selection = this.props.state.selectedFundings;
    if(!this.maxSelections(selection.length) && !selection.includes(fm)) {
      selection.push(fm);
    } else
    if(selection.includes(fm)) {
      selection = selection.filter((value) => { return value !== fm; });
    }
    this.setState({
      selectedFundings: selection
    }, function() { this.props.updateState( {selectedFundings: this.state.selectedFundings, prevSelectedFunding: fm} )});
  };

  toggleSection(e, key, cardId) {
    e.stopPropagation();
    if(this.animToggleTimer[key]) clearTimeout(this.animToggleTimer[key]);
    if(this.state.curTab === key) {
      this.setState({curTab: null, cardId: null});
    } else {
      this.setState({curTab: key, cardId: cardId});
    }
    setTimeout(() => {
        this.setState({toggling: true});
    },20);
    this.animToggleTimer[key] = setTimeout(() => {
      this.setState({toggling: false});
      UpdateParentWindow(this.props.state, this.props.updateState);
      clearTimeout(this.animToggleTimer[key]);
    }, this.toggleAnimDuration);
  }

  render() {
    let error = (this.maxSelections(this.props.state.selectedFundings.length) &&
                 this.props.state.prevSelectedFunding === this.props.model.slug &&
                 !this.props.state.selectedFundings.includes(this.props.state.prevSelectedFunding)) ?
                  <span className="error">Olet jo valinnut kolme rahoitusmallia</span> : null;

    let state = this.props.state;
    let calc = CalculatePayments(this.props.model.slug, this.props.model.title, state.investmentSize, state.payBackTime,
                                 state.completionYear, state.varsLoanInterest, state.varsGreenLoanInterest,
                                 state.varsLeasingInterest, state.varsLeasingResidualValue, state.varsGreenLeasingInterest,
                                 state.varsGreenLeasingResidualValue, state.varsLongRentInitialRent, state.varsLongRentIndexing,
                                 state.varsLongRentRedemptionValue, state.varsShortRentInitialRent,
                                 state.varsShortRentIndexing, state.varsShortRentRedemptionValue, state.varsLeasingContractTime,
                                 state.varsGreenLeasingContractTime);

    return (
      <div className="card-wrapper">
        <div className={"column-container" + ((this.props.selected) ? " selected" : "")} style={{display: "inline-flex"}}>
          <div className="col-left">
            <div className={"card" + ((this.props.selected) ? " selected" : "")}
                    tabIndex="0"
                    onClick={() => {this.selectFundingModel(this.props.model.slug)}}>
              {error}
              <span className="title">{this.props.model.title}</span>
              <span className="description">{this.props.model.description}</span>

              <div className="card-tabs">
                <div className={"card-tab" +
                    (this.state.curTab === 'yearcost' && this.props.model.slug === this.state.cardId ? " card-tab--active" : "")}
                    onClick={(e) => {this.toggleSection(e, 'yearcost', this.props.model.slug)}}>
                  Vuosikustannukset
                </div>
                {this.props.model.benefits || this.props.model.disadvantages ?
                  <div className={"card-tab" +
                      (this.state.curTab === 'proscons' && this.props.model.slug === this.state.cardId ? " card-tab--active" : "")}
                      onClick={(e) => {this.toggleSection(e, 'proscons', this.props.model.slug)}}>
                    Ominaisuudet
                  </div>
                  : null
                }
              </div>
            </div>
          </div>
          <div className="col-right">
            <div>
              Pääomakustannukset
              <span className="price">
                {calc.sum.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")} €
              </span>
              <span className="second">
                1. vuoden kustannukset
                <span className="price">
                  {(Math.round(calc.years[1].sum / 1000) * 1000).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")} €
                </span>
              </span>
            </div>
          </div>
        </div>
        {this.props.model.benefits || this.props.model.disadvantages ?
          <div className={"card-tab-content" +
            (this.state.curTab === 'proscons' && this.props.model.slug === this.state.cardId ? " card-tab-content--open" : "") +
            (this.state.toggling ? " card-tab-content--toggling" : "")}
            style={{transitionDuration: this.toggleAnimDuration + "ms"}}>
              <FundingProsAndCons benefits={this.props.model.benefits} disadvantages={this.props.model.disadvantages}></FundingProsAndCons>
          </div>
        :null}
        <div className={"card-tab-content funding-model-and-price" +
          (this.state.curTab === 'yearcost' && this.props.model.slug === this.state.cardId ? " card-tab-content--open" : "") +
          (this.state.toggling ? " card-tab-content--toggling" : "")}
          style={{transitionDuration: this.toggleAnimDuration + "ms"}}>
            <div className="fund-model-graph">
              <div className="col-left">
                <ComparisonGraph graphData={[calc]} compact={true} />
              </div>
              <div className="col-right">
                <div>
                  <h4>Pääomakustannukset:</h4>
                  Vuosikustannusten summa, sisältäen korot ja pääoman
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default FundingModel;
